import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Pages
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ExpertisesPage from "./pages/ExpertisesPage";
import ComprendrePage from "./pages/ComprendrePage";
import PublicationsPage from "./pages/PublicationsPage";
import TestimonialsPage from "./pages/TestimonialsPage";
import ContactPage from "./pages/ContactPage";
import LegalPage from "./pages/LegalPage";
import AdminPage from "./pages/AdminPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/a-propos" element={<AboutPage />} />
          <Route path="/expertises" element={<ExpertisesPage />} />
          <Route path="/comprendre" element={<ComprendrePage />} />
          <Route path="/publications" element={<PublicationsPage />} />
          <Route path="/temoignages" element={<TestimonialsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/mentions-legales" element={<LegalPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
